/**
 * scroll-port.ts — the one scroll container of the app, handed down to whoever windows on it.
 *
 * `Shell` owns the scroller (the screen above the tabs) and provides it here; `VirtualList`
 * reads it. A context rather than a DOM search because the search depends on computed styles,
 * and a stylesheet that has not loaded yet — or a test environment that loads none — would
 * make the list window against the wrong element without any error to show for it.
 *
 * `null` until `Shell` has mounted the element.
 */

import { createContext } from 'react';

export const ScrollPortContext = createContext<HTMLElement | null>(null);
